import { Component, Input, Output, EventEmitter } from "@angular/core";
import { NgxSmartModalService } from "ngx-smart-modal";

@Component({
  selector: "app-bulk-upload-errors-modal",
  templateUrl: "./bulk-upload-errors-modal.component.html",
  styleUrls: ["./bulk-upload-errors-modal.component.css"],
})
export class BulkUploadErrorsModalComponent {
  isLoadingGeneral = false;
  // null when the report is too large to return; `message` explains why.
  @Input() errorsFile: unknown = null;
  @Input() message: string | null = null;
  @Output() changeErrors: EventEmitter<any> = new EventEmitter();

  constructor(public ngxSmartModalService: NgxSmartModalService) {}

  close() {
    this.ngxSmartModalService.closeLatestModal();
  }

  downloadSpreadsheet() {
    this.changeErrors.emit();
  }
}
